import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-icon-button',
  templateUrl: './delete-icon-button.component.html',
  styleUrls: ['./delete-icon-button.component.scss']
})
export class DeleteIconButtonComponent implements OnInit {
  @Input() icon = "delete";
  @Input() label = "DELETE";
  @Input() disabled = false;

  constructor() { }

  ngOnInit(): void {
  }

}
